var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "matrixTableWrapper", staticClass: "matrix-table-wrapper" },
    [
      _vm.matrixLayout.rows
        ? _c(
            "table",
            { ref: "matrixTable", staticClass: "matrix-table not-print" },
            [
              _c("thead", [
                _vm.matrixLayout.columns
                  ? _c(
                      "tr",
                      [
                        _c("td", { staticStyle: { width: "150px" } }),
                        _vm._l(_vm.matrixLayout.columns, function (column) {
                          return _c("td", { key: column.id }, [
                            _vm._v(" " + _vm._s(column.label) + " "),
                          ])
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.matrixLayout.rows, function (row) {
                  return _c(
                    "tr",
                    { key: row.id },
                    [
                      _c("td", { staticStyle: { width: "150px" } }, [
                        _vm._v(" " + _vm._s(row.label) + " "),
                      ]),
                      _vm.type === "MATRIX_INPUT"
                        ? _vm._l(_vm.matrixLayout.columns, function (column) {
                            return _c("td", { key: column.id }, [
                              _c("div", [
                                _vm.value[row.id]
                                  ? _c(
                                      "span",
                                      {
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.value[row.id][column.id]) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ])
                          })
                        : _vm._e(),
                      _vm.type === "MATRIX_SELECT"
                        ? [
                            _c(
                              "td",
                              {
                                attrs: {
                                  colspan: _vm.matrixLayout.columns.length,
                                },
                              },
                              [
                                Array.isArray(_vm.value[row.id])
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.value[row.id].join(","))
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(" " + _vm._s(_vm.value[row.id])),
                                    ]),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm.type === "MATRIX_SCALE"
                        ? [
                            _c("td", [
                              _vm._v(" " + _vm._s(_vm.value[row.id]) + " "),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _c("div", {
        ref: "matrixTablePrintWrapper",
        staticClass: "matrix-table-print-wrapper print",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }